<template>
  <!-- 详情未登录 -->
  <div class="DetailsLogIn">
    <Head />
    <!-- 详情未登录的头部nav -->

    <div class="main Data">
      <el-row>
        <el-col :xs="24" class="map">
          <DataMap :msg="data4" />
        </el-col>

        <el-col>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="8" class="DataList">
              <DataStartH :msg="StartHData" />
            </el-col>
            <el-col :xs="24" :sm="8" class="DataList">
              <DataHotH />
            </el-col>
            <el-col :xs="24" :sm="8" class="DataList">
              <DataStartJD />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <Foot />

   
  </div>
</template>

<script>
import Head from "@/components/Head/Head.vue";
import Foot from "@/components/Foot/Foot.vue";
import DataMap from "@/components/DockingSystem/Data/Map.vue";
import DataStartH from "@/components/DockingSystem/Data/StartH.vue";
import DataStartJD from "@/components/DockingSystem/Data/StartJD.vue";
import DataHotH from "@/components/DockingSystem/Data/HotH.vue";
export default {
  props: {},
  components: {
    Head,
    Foot,
    DataMap,
    DataStartH,
    DataStartJD,
    DataHotH,
  },
  data() {
    return {
      // loginType:false,//登录状态,false为未登录
      loginType: true, //登录状态,true为已登录

      data4: [],
      StartHData: [],
    };
  },
  created: function() {},
  methods: {},
};
</script>

<style scoped>
.DataList {
}
.map{
  padding: 20px 0;
}
.Data {
  padding-bottom: 50px;
}
</style>
